<template>
  <div class="flexwrap centercenter" style="width: 100%; height: 100%;">
    <div class="container flexwrap centercenter">
      <div class="loadingLogo" :style="{ backgroundImage: 'url(' + require('../assets/logo_small.png')+ ')' }">
      </div>
    </div>
  </div>


</template>

<script>
export default {
name: "loadingLogo"
}
</script>

<style scoped>
.container{
  height: 5vw;
  width: 5vw;
}

@keyframes loadinga {
  0%   {width: 4vw;height: 4vw;transform: rotate(0deg);}
  10%   {width: 4vw;height: 4vw;transform: rotate(0deg);}
  15%  {width: 5vw;height: 5vw;transform: rotate(0deg);}
  /*40%  {width: 30%;transform: rotate(90deg);}
  55%  {width: 30%;transform: rotate(180deg);}
  70%  {width: 30%;transform: rotate(270deg);}*/
  85%  {width: 5vw;height: 5vw;transform: rotate(360deg);}
  100% {width: 4vw;height: 4vw;transform: rotate(360deg);}
}
  .loadingLogo{
    width: 4vw;
    height: 4vw;
    animation: loadinga 2s infinite ease;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center center;
  }

@media screen and (max-device-width: 767px) {
  .container{
    height: 15vw;
    width: 15vw;
  }

  @keyframes loadinga {
    0%   {width: 12vw;height: 12vw;transform: rotate(0deg);}
    10%   {width: 12vw;height: 12vw;transform: rotate(0deg);}
    15%  {width: 15vw;height: 15vw;transform: rotate(0deg);}
    /*40%  {width: 30%;transform: rotate(90deg);}
    55%  {width: 30%;transform: rotate(180deg);}
    70%  {width: 30%;transform: rotate(270deg);}*/
    85%  {width: 15vw;height: 15vw;transform: rotate(360deg);}
    100% {width: 12vw;height: 12vw;transform: rotate(360deg);}
  }
  .loadingLogo{
    width: 12vw;
    height: 12vw;
  }

}
</style>